import Vue from "vue";
import "./plugins/vuetify";
import App from "./App.vue";
import router from "@/router";

import jquery from "vue-jquery";
import store from "./plugins/store"
import moment from "moment"
import apiConfig from '@/services/apiConfig';
import ApiService from "@/common/api.service";

moment.locale('pt-BR');

if (apiConfig.getUrlAgendaServicosApi()) {
  ApiService.init();
}

Vue.config.productionTip = false;

new Vue({
  jquery,
  store,
  router,
  render: h => h(App)
}).$mount("#app");
